import { t } from "i18next";
import { Link, useOutletContext } from "react-router-dom";

const EventReports = () => {
  const { event, selectedLanguage } = useOutletContext();

  const reports = [
    {
      section: t("Event Reports"),
      description: t(
        "Track sales for your event\nReports may not reconcile with dancebrite payouts if they include financial amounts not collected by Dancebrite, such as cash, <a href='/' target='_blank'>manual</a> or <a href='/' target='_blank'>offline sales</a>."
      ),
      items: [
        {
          title: t("Orders"),
          description: t(
            "Buyer details including a cost breakdown of each order"
          ),
          icon: "fa-light fa-boxes",
          link: `/${selectedLanguage}/user/myEvent/report/order-reports/${event?.data?.uid}`,
        },
        {
          title: t("Sales Summary"),
          description: t(
            "An overview of all ticket and add-on sales, including fees and taxes, aggregated by event"
          ),
          icon: "fa-light fa-chart-line",
          link: `/${selectedLanguage}/user/myEvent/report/order-sales/${event?.data?.uid}`,
        },
        {
          title: t("Sales by ticket type"),
          description: t(
            "An overview of all ticket sales, including fees and taxes"
          ),
          icon: "fa-light fa-file-chart-column",
          link: `/${selectedLanguage}/user/myEvent/report/tickets-sales/${event?.data?.uid}`,
        },
      ],
    },
    {
      section: t("Attendees"),
      description: t("View details about your attendees"),
      items: [
        {
          title: t("Attendees"),
          description: t(
            "List of each attendee, including their email addresses"
          ),
          icon: "fa-light fa-users",
          link: `/${selectedLanguage}/user/myEvent/report/attendee/${event?.data?.uid}`,
        },
        {
          title: t("Add-ons"),
          description: t("List of each attendee who purchased an Add-on"),
          icon: "fa-light fa-puzzle-piece",
          link: `/${selectedLanguage}/user/myEvent/report/attendee-addon/${event?.data?.uid}`,
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="divide-y divide-slate-100">
        {reports.map((section, index) => (
          <div key={index} className="relative py-3 space-y-4">
            <div className="space-y-2 w-full">
              <h2 className="text-2xl text-slate-900 font-bold font-Montserrat">
                {section?.section}
              </h2>
              <div className="text-base text-slate-500 font-Nunito whitespace-pre-wrap leading-snug"></div>
            </div>
            <div className="grid lg:grid-cols-3 gap-4">
              {section.items.map((item, subindex) => (
                <Link
                  key={subindex}
                  to={item?.link}
                  className="group relative shadow rounded-lg bg-white cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline"
                >
                  <div className="py-6 px-4 flex items-start gap-4">
                    <div className="flex-shrink flex-grow space-y-3">
                      {item?.title && (
                        <h3 className="text-base font-bold text-slate-900 group-hover:text-primary transition-all duration-300 leading-tight">
                          {item?.title}
                        </h3>
                      )}
                      {item?.description && (
                        <div className="text-sm text-slate-500 font-Nunito">
                          {item?.description}
                        </div>
                      )}
                    </div>
                    <div className="flex-shrink-0 flex items-center justify-center w-12 md:w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
                      <i className={item?.icon}></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventReports;
